// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductMiniCardStyles } from "@guestsupply/App/Components/Product/ProductMiniCard";
import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { featuredProductsCarouselStyles } from "@guestsupply/App/Widgets/FeaturedProductsCarousel/FeaturedProductsCarousel";
import { createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import Plus from "@insite/mobius/Icons/Plus";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

const productMiniCardStyles: ProductMiniCardStyles = {
    productPartNumbersStyles: {
        container: {
            css: css`
                margin-top: 0;
            `,
        },
    },
    productDescription: {
        productDetailLink: {
            css: css`
                margin-bottom: 4px; /* Take in the consideration gap 4px */
            `,
        },
    },
};

featuredProductsCarouselStyles.container = {
    css: css`
        margin: 25px 0;
    `,
};

featuredProductsCarouselStyles.productCategoriesSelect = {
    css: css`
        margin-bottom: 12px;
    `,
};

featuredProductsCarouselStyles.carouselProductWrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};

featuredProductsCarouselStyles.carouselProductStyles = {
    productDescriptionStyles: {
        ...createProductDescriptionStyles(),
    },
    productPriceStyles: {
        price: {
            priceText: {
                size: 18,
            },
            unitOfMeasure: {
                unitOfMeasureText: {
                    size: 13,
                },
            },
        },
    },
    addToCartContainer: {
        css: css`
            margin-bottom: 12px;
        `,
    },
    productAddToListLinkStyles: {
        link: {
            ...createLinkIconStyles(Plus, {
                typographyProps: {
                    size: 12,
                    weight: "bold",
                    css: css`
                        margin-left: 2px;
                        line-height: 12px;
                    `,
                },
                icon: {
                    position: "left",
                    iconProps: {
                        size: 8,
                        color: "text.link",
                    },
                },
            }),
        },
    },
};

featuredProductsCarouselStyles.productMiniCardStyles = {
    ...productMiniCardStyles,
};

featuredProductsCarouselStyles.swiperStyles = {
    container: {
        css: css`
            .swiper-wrapper {
                z-index: ${getProp("theme.zIndex.tabGroup")};
            }
        `,
    },
};

featuredProductsCarouselStyles.productsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 25px 21px;
    `,
};

featuredProductsCarouselStyles.productMiniCardWrapper = {
    css: css`
        flex-basis: 100%;
    `,
};

featuredProductsCarouselStyles.productMiniCardGridViewStyles = {
    ...productMiniCardStyles,
    productGridContainerStyles: {
        container: {
            css: css`
                min-height: 100%;
                width: calc(100% / 3 - 14px);
                max-width: calc(100% / 3 - 14px);
                ${xScreen("lte", 1320)} {
                    width: calc(50% - 14px);
                    max-width: calc(50% - 14px);
                }

                ${xScreen("lte", "md")} {
                    max-width: 100%;
                    width: 100%;
                }
            `,
        },
    },
};

featuredProductsCarouselStyles.productWrapper = {
    css: css`
        min-height: 100%;
        width: calc(100% / 3 - 14px);
        .product-grid-container {
            max-width: 100%;
        }
        ${xScreen("lte", 1320)} {
            width: calc(50% - 14px);
        }

        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
